import { usePermissions, useRedirect } from 'react-admin'
import { PolicyAdd as SharedPolicyAdd } from 'shared/components/Policies/PolicyAdd'

import { useTeam } from '../../helpers/useTeam'
import { ConsoleUserProvider } from '../Context/ConsoleUserProvider'

export function PolicyAdd({ match }: any) {
  const { teamId } = match.params
  const team = useTeam(teamId)
  const redirect = useRedirect()
  const { permissions } = usePermissions()

  if (!team) {
    return null
  }

  return (
    <ConsoleUserProvider
      isPremium={false}
      isFlexStarter={false}
      hasStarterFeature={false}
      hasFactoringFeature={false}
      permissions={permissions}
    >
      <SharedPolicyAdd
        team={team}
        teamUrl={`/teams/${teamId}/show`}
        onCancel={() => redirect(`/teams/${teamId}/show/repayments`)}
      />
    </ConsoleUserProvider>
  )
}
